import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  BaseWebsocketMessage,
  SubWebsocketMessageRequest,
  WebsocketEntTypes,
  WebSocketService,
  WSEntityManager,
} from '@qtek/core/websockets-core';
import { DocumentTemplate } from '@qtek/shared/models';
import { Observable } from 'rxjs';
import { HttpEntityManager } from '../http-entity-manager';

@Injectable({
  providedIn: 'root',
})
export class DocumentTemplateDataService extends HttpEntityManager<
  DocumentTemplate,
  DocumentTemplate
> {
  protected http = inject(HttpClient);
  private webSocketService = inject(WebSocketService);

  entityName: WebsocketEntTypes = 'tpldta';
  wsManager = new WSEntityManager(this.webSocketService, this.entityName);

  readonly webSocketIsAlive$ = this.webSocketService.getWebSocketIsAlive$();

  constructor() {
    super();
  }

  subscribe(
    payload: Omit<SubWebsocketMessageRequest, 'ent' | 'op'>
  ): Observable<BaseWebsocketMessage> {
    return this.wsManager.subscribeEntity({ ...payload });
  }

  getTemplateData(id: string, dealId: string): void {
    this.wsManager.get({
      id,
      prms: { dealId },
    });
  }

  getTemplateDataHistory(id: string): void {
    this.wsManager.query({
      id,
    });
  }

  createDocumentTemplateData(tplId: string): void {
    this.wsManager.create({ res: { tplId } });
  }

  updateDocumentTemplateData(id: string, res: any): void {
    this.wsManager.update({ res, id });
  }

  deleteDocumentTemplate(documentTemplateId: string): void {
    this.wsManager.delete({ id: documentTemplateId });
  }
}
